export default __webpack_public_path__ + "static/media/desolate-jungle.58fe8bbb.gif";